export enum UiDictionaryType {
  ProvisionType = 'provision_type',
  PriceType = 'price_type',
  DomainObjectType = 'domain_object_type',
  HighlightingType = 'highlighting_type',
  FixingPriceOperationStatus = 'fixing_price_operation_status',
  UserRole = 'user_role',
  PermissionType = 'permission-type',
  CreateDocumentForSellingOperationStatus = 'create_document_for_selling_operation_status',
  UpdateDocumentForSellingOperationStatus = 'update_document_for_selling_operation_status',
  TransactionDirection = 'transaction_direction',
  OrderStatus = 'order_status',
}
